import { useRouter } from 'next/router';
import { twJoin } from 'tailwind-merge';

import ToggleBadge from 'molecules/Badge/ToggleBadge';
import Button from 'molecules/Button';
import DropDown from 'molecules/Dropdown';

import useVideosListingStore, { clearVideosFilters, updateVideosFilters } from 'layout/Listing/variants/videos/store';

import videosCategories from 'data/videosTags.json';

import type { FC } from 'react';

interface VideosFiltersProps {}

const VideosFilters: FC<VideosFiltersProps> = () => {
  const filter = useVideosListingStore(state => state.filters);
  const router = useRouter();

  return (
    <>
      {videosCategories.length > 0 && (
        <div className="col-span-full hidden flex-wrap items-center gap-4 lg:flex">
          <ToggleBadge
            label="All"
            defaultPressed
            pressed={filter === 'All'}
            onPressedChange={e => e && updateVideosFilters(router, 'All')}
          />
          {videosCategories.map(category => (
            <ToggleBadge
              key={category}
              label={category}
              pressed={filter === category}
              onPressedChange={(pressed: boolean) => pressed && updateVideosFilters(router, category)}
            />
          ))}
          <Button
            className={twJoin(filter === 'All' && 'hidden')}
            hierarchy="linkGray"
            startIcon="x-circle"
            label="Clear Filters"
            onClick={clearVideosFilters}
          />
        </div>
      )}

      <div className="flex items-center lg:hidden">
        <Button
          className={twJoin(filter === 'All' && 'hidden')}
          hierarchy="linkGray"
          startIcon="x-circle"
          label="Clear Filters"
          onClick={clearVideosFilters}
        />
      </div>
      <div className="lg:hidden">
        <DropDown
          placeholder="Filter by category"
          options={videosCategories}
          value={[filter]}
          onChange={e => updateVideosFilters(router, e as string)}
        />
      </div>
    </>
  );
};

export default VideosFilters;
